<template>
    <!-- Service Section -->
	<section class="section service-section">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center">
						<h2 class="mb-1">Our Featured <span class="text-linear-primary">Services</span></h2>
						<p class="sub-title">Each listing is designed to be clear and concise, providing customers</p>
					</div>
				</div>
			</div>
			<div class="service-slider owl-carousel nav-center">
                <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                    <Slide v-for="item in HomeSwiper" :key="item.id">
                        <div class="service-item wow fadeInUp" data-wow-delay="0.2s">
                            <div class="service-img">
                                <div class="img-slider owl-carousel nav-center">
                                    <Carousel :wrap-around="true" :settingsOne="settingsOne" :breakpointsOne="breakpointsOne">
                                        <Slide v-for="slideItem in item.Slider" :key="slideItem.id">
                                            <div class="slide-images">
                                                <router-link to="/details/service-details">
                                                    <img :src="require(`@/assets/img/services/${slideItem.Image}`)" class="img-fluid" alt="img">
                                                </router-link>
                                            </div>
                                        </Slide>
                                        <template #addons>
                                            <Navigation />
                                            <Pagination />
                                        </template>
                                    </Carousel>
                                </div>
                                <template v-if="item.TradeIcon">
                                    <div class="trend-icon">
                                        <span class="bg-success">
                                            <i class="feather-trending-up"></i>
                                        </span>
                                    </div>
                                </template>                                
                                <div class="fav-item">
                                    <a href="javascript:void(0);" class="fav-icon">
                                        <i class="ti ti-heart"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="service-content text-start">
                                <h6 class="text-truncate mb-1"><router-link to="/details/service-details">{{item.Title}}</router-link>
                                </h6>
                                <div class="d-flex align-items-center justify-content-between">
                                    <p class="fw-medium fs-14 mb-0">{{item.Text}}</p>
                                    <span class="d-inline-flex align-items-center fs-14"><i
                                            class="ti ti-star-filled text-warning me-1"></i>{{item.Rating}}</span>
                                </div>
                            </div>
                        </div>
                    </Slide>
                    <template #addons>
                        <Navigation />
                    </template>
                </Carousel>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="text-center wow fadeInUp mt-5" data-wow-delay="0.2s">
						<router-link to="/service/search" class="btn btn-dark">View All<i
							class="ti ti-arrow-right ms-2"></i></router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /Service Section -->
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import HomeSwiper from '@/assets/json/frontend/home-services.json'
import "vue3-carousel/dist/carousel.css";

export default {
  data() {
    return {
        HomeSwiper: HomeSwiper,
        settings: {
            itemsToShow: 1,
            snapAlign: "center",
        },
        breakpoints: {
            575: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            767: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            991: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "start",
            },
        },
        settingsOne: {
            itemsToShow: 1,
            snapAlign: "center",
        },
        breakpointsOne: {
            575: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            767: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            991: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "start",
            },
        },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
};
</script>